import React, { useEffect } from 'react'
import './GroupPopup.scss'

const GroupPopup = ({ show, onClose, onSubmit, selectedGroup, setSelectedGroup, groupList, t }) => {
    useEffect(() => {
        if (!selectedGroup) {
          setSelectedGroup("");
        }
      }, [selectedGroup, setSelectedGroup]);

    if (!show) return null;
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <span className='select-group-text'>{t("common.selectGroup")}</span>
                <div className='modal-body'>
                    <select value={selectedGroup} onChange={(e) => setSelectedGroup(e.target.value)}>
                        <option value="">{t("common.default")}</option>
                        {groupList?.map((group) => (
                            <option value={group?.id}>{group?.group_name}</option>
                        ))}
                    </select>
                    <div className="modal-actions">
                        <button className="cancel-btn" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                        <button className="submit-btn" onClick={onSubmit}>
                            {t('common.submit')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GroupPopup